// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.
// Pre-formatted for Stitches — pass directly to loadTheme without runtime formatting.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSStitchesFormattedTheme } from '@leagueplatform/genesis-core';

export const eOSHealthDemoLightTheme: GDSStitchesFormattedTheme = {
  rem: {
    space: {
      none: '0',
      quarter: '0.25rem',
      half: '0.5rem',
      threeQuarters: '0.75rem',
      one: '1rem',
      oneAndHalf: '1.5rem',
      two: '2rem',
      twoAndHalf: '2.5rem',
      three: '3rem',
      four: '4rem',
      five: '5rem',
      eighth: '0.125rem',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
      minusQuarter: '-0.25rem',
      minusHalf: '-0.5rem',
      minusThreeQuarters: '-0.75rem',
      minusOne: '-1rem',
      minusOneAndHalf: '-1.5rem',
      minusTwo: '-2rem',
      minusTwoAndHalf: '-2.5rem',
      minusThree: '-3rem',
      minusFour: '-4rem',
      minusFive: '-5rem',
      minusEighth: '-0.125rem',
    },
    sizes: {
      none: '0',
      quarter: '0.25rem',
      half: '0.5rem',
      threeQuarters: '0.75rem',
      one: '1rem',
      oneAndHalf: '1.5rem',
      two: '2rem',
      twoAndHalf: '2.5rem',
      three: '3rem',
      four: '4rem',
      five: '5rem',
      eighth: '0.125rem',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
    },
    fontSizes: {
      headingOne: '2rem',
      headingTwo: '1.5rem',
      headingThree: '1.25rem',
      headingFour: '1.125rem',
      subtitleOne: '1rem',
      subtitleTwo: '0.875rem',
      bodyOne: '1rem',
      bodyOneSecondary: '1rem',
      bodyTwo: '0.875rem',
      bodyTwoSecondary: '0.875rem',
      buttonOne: '1rem',
      buttonTwo: '0.875rem',
      label: '0.75rem',
      overline: '0.75rem',
      caption: '0.75rem',
      tab: '0.625rem',
    },
    lineHeights: {
      headingOne: '2.5rem',
      headingTwo: '2rem',
      headingThree: '1.75rem',
      headingFour: '1.5rem',
      subtitleOne: '1.5rem',
      subtitleTwo: '1.25rem',
      bodyOne: '1.5rem',
      bodyOneSecondary: '1.5rem',
      bodyTwo: '1.25rem',
      bodyTwoSecondary: '1.25rem',
      buttonOne: '1.5rem',
      buttonTwo: '1.25rem',
      label: '1rem',
      overline: '1rem',
      caption: '1rem',
      tab: '0.75rem',
    },
  },
  px: {
    space: {
      none: '0',
      quarter: '4px',
      half: '8px',
      threeQuarters: '12px',
      one: '16px',
      oneAndHalf: '24px',
      two: '32px',
      twoAndHalf: '40px',
      three: '48px',
      four: '64px',
      five: '80px',
      eighth: '2px',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      bodyOne: '$half',
      bodyOneSecondary: '$half',
      bodyTwo: '$half',
      bodyTwoSecondary: '$half',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
      minusQuarter: '-4px',
      minusHalf: '-8px',
      minusThreeQuarters: '-12px',
      minusOne: '-16px',
      minusOneAndHalf: '-24px',
      minusTwo: '-32px',
      minusTwoAndHalf: '-40px',
      minusThree: '-48px',
      minusFour: '-64px',
      minusFive: '-80px',
      minusEighth: '-2px',
    },
    sizes: {
      none: '0',
      quarter: '4px',
      half: '8px',
      threeQuarters: '12px',
      one: '16px',
      oneAndHalf: '24px',
      two: '32px',
      twoAndHalf: '40px',
      three: '48px',
      four: '64px',
      five: '80px',
      eighth: '2px',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      bodyOne: '$half',
      bodyOneSecondary: '$half',
      bodyTwo: '$half',
      bodyTwoSecondary: '$half',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
    },
    fontSizes: {
      headingOne: '32px',
      headingTwo: '24px',
      headingThree: '20px',
      headingFour: '18px',
      subtitleOne: '16px',
      subtitleTwo: '14px',
      bodyOne: '16px',
      bodyOneSecondary: '$bodyOne',
      bodyTwo: '14px',
      bodyTwoSecondary: '$bodyTwo',
      buttonOne: '16px',
      buttonTwo: '14px',
      label: '12px',
      overline: '12px',
      caption: '12px',
      tab: '10px',
    },
    lineHeights: {
      headingOne: '40px',
      headingTwo: '32px',
      headingThree: '28px',
      headingFour: '24px',
      subtitleOne: '24px',
      subtitleTwo: '20px',
      bodyOne: '24px',
      bodyOneSecondary: '$bodyOne',
      bodyTwo: '20px',
      bodyTwoSecondary: '$bodyTwo',
      buttonOne: '24px',
      buttonTwo: '20px',
      label: '16px',
      overline: '16px',
      caption: '16px',
      tab: '12px',
    },
  },
  colors: {
    surfaceBackgroundPrimary: '#F7F5F4FF',
    surfaceBackgroundSecondary: '#F2EFEBFF',
    surfaceBackgroundTertiary: '#E9E3FFFF',
    surfaceCardPrimary: '#F7F5F4FF',
    surfaceCardSecondary: '#FFFFFFFF',
    surfaceCardDisabled: '#D7D7D7FF',
    surfaceScreenHeaderBackground: '#DCD1FFFF',
    surfaceSkeletonShimmerBackground: '#E7E7E7FF',
    surfaceSkeletonShimmerOverlay:
      'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
    onSurfaceTextPrimary: '#191919FF',
    onSurfaceTextSubdued: '#424242FF',
    onSurfaceTextReversed: '#FFFFFFFF',
    onSurfaceTextCritical: '#DD0E0EFF',
    onSurfaceTextSuccess: '#507C03FF',
    onSurfaceTextWarning: '#C94F08FF',
    onSurfaceBorderSubdued: '#E1DFDBFF',
    onSurfaceBorderDefault: '#C8C6C2FF',
    onSurfaceBorderCard: '#E1DFDBFF',
    onSurfaceIconPrimary: '#191919FF',
    interactiveActionPrimary: '#191919FF',
    interactiveActionHovered: '#393939FF',
    interactiveActionPressed: '#1A1A1AFF',
    interactiveActionSubdued: '#484848FF',
    interactiveActionDisabled: '#D6D6D6FF',
    interactiveIconDefault: '#FFFFFFFF',
    interactiveIconDisabled: '#949494FF',
    interactiveBackgroundDefault: '#FFFFFFFF',
    interactiveBackgroundDisabled: '#E8EAEDFF',
    interactiveBackgroundHovered: '#F8F8F8FF',
    interactiveBackgroundPressed: '#F0F0F0FF',
    interactiveBorderDefault: '#949494FF',
    interactiveBorderHovered: '#4E4E4EFF',
    interactiveBorderDisabled: '#D6D6D6FF',
    interactiveBorderCriticalDefault: '#DD0E0EFF',
    interactiveFocusInner: '#1A1A1AFF',
    interactiveFocusOuter: '#1A1A1AFF',
    criticalBackgroundSubdued: '#F9E1E2FF',
    criticalBackgroundSecondary: '#FFFFFFFF',
    criticalBorderDefault: '#DD0E0EFF',
    criticalIcon: '#DD0E0EFF',
    warningBackgroundSubdued: '#FAE8D6FF',
    warningBackgroundSecondary: '#FFFFFFFF',
    warningBorderDefault: '#C94F08FF',
    warningIcon: '#C94F08FF',
    successBackgroundSubdued: '#F6FCEBFF',
    successBackgroundSecondary: '#FFFFFFFF',
    successBorderDefault: '#507C03FF',
    successIcon: '#507C03FF',
    highlightBackgroundSubdued: '#EDF8FFFF',
    highlightBackgroundSecondary: '#FFFFFFFF',
    highlightBorderDefault: '#2E5CDFFF',
    highlightIcon: '#2E5CDFFF',
    decorativeBrandPrimaryDarkest: '#DB6E43FF',
    decorativeBrandPrimaryDark: '#FA9872FF',
    decorativeBrandPrimaryDefault: '#FFB89CFF',
    decorativeBrandPrimaryBright: '#FFD6C5FF',
    decorativeBrandPrimaryBrightest: '#FFEFE8FF',
    decorativeBrandPrimaryPastel: '#F2EBE7FF',
    decorativeBrandSecondaryDarkest: '#504691FF',
    decorativeBrandSecondaryDark: '#8377D1FF',
    decorativeBrandSecondaryDefault: '#B1A5FFFF',
    decorativeBrandSecondaryBright: '#D5CBFDFF',
    decorativeBrandSecondaryBrightest: '#E9E4FFFF',
    decorativeBrandSecondaryPastel: '#F8F6FFFF',
    decorativeBrandTertiaryDarkest: '#D7A100FF',
    decorativeBrandTertiaryDark: '#E7AD00FF',
    decorativeBrandTertiaryDefault: '#FBC31BFF',
    decorativeBrandTertiaryBright: '#FFDC73FF',
    decorativeBrandTertiaryBrightest: '#FFDC73FF',
    decorativeBrandTertiaryPastel: '#FFFAEDFF',
    primaryBackgroundDefault: '#191919FF',
    primaryBackgroundHovered: '#000000FF',
    primaryBackgroundPressed: '#1A1A1AFF',
    primaryBackgroundCriticalDefault: '#DD0E0EFF',
    primaryBackgroundCriticalHovered: '#B51414FF',
    primaryBackgroundCriticalPressed: '#DD0E0EFF',
    primaryTextDefault: '#FFFFFFFF',
    primaryTextCriticalDefault: '#FFFFFFFF',
    secondaryBackgroundDefault: '#F7F7F7FF',
    secondaryBackgroundHovered: '#DCDCDCFF',
    secondaryBackgroundPressed: '#F0F0F0FF',
    secondaryTextDefault: '#191919FF',
    secondaryTextHovered: '#1A1A1AFF',
    secondaryBorderDefault: '#1A1A1AFF',
    tertiaryBackgroundDefault: '#FFFFFF00',
    tertiaryBackgroundHovered: '#DCDCDCFF',
    tertiaryBackgroundPressed: '#F0F0F0FF',
    tertiaryTextDefault: '#4C4C4CFF',
    tertiaryTextHovered: '#1A1A1AFF',
    tertiaryBorderDefault: '#DCDCDCFF',
    inputBorderSuccess: '#507C03FF',
    inputBorderWarning: '#C94F08FF',
    inputBorderDefault: '#949494FF',
    inputBorderHovered: '#4E4E4EFF',
    inputBorderDisabled: '#D6D6D6FF',
    inputBorderCritical: '#DD0E0EFF',
    inputBackgroundDefault: '#FFFFFFFF',
    inputBackgroundDisabled: '#E8EAEDFF',
    inputBackgroundHovered: '#F8F8F8FF',
    inputBackgroundPressed: '#F0F0F0FF',
    dataVizInterfaceTrackBorder: '#F5F5F5FF',
    dataVizInterfaceTrackBackground: '#F5F5F5FF',
    dataVizSingleColorBrand: '#8070E5FF',
    dataVizSingleColorNeutral: '#959595FF',
    dataVizStatusCritical: '#DD0E0EFF',
    dataVizStatusWarning: '#F16501FF',
    dataVizStatusSuccess: '#0DA80AFF',
    dataVizCategoricalOne: '#1A1A1AFF',
    dataVizCategoricalTwo: '#8070E5FF',
    dataVizCategoricalThree: '#E95578FF',
    dataVizCategoricalFour: '#2393C3FF',
    dataVizCategoricalFive: '#D86B27FF',
    dataVizCategoricalSix: '#009F67FF',
    tagNeutralBackgroundBold: '#3B3B3BFF',
    tagNeutralBackgroundSubdued: '#E9E9E9FF',
    tagNeutralBorderBold: '#3B3B3BFF',
    tagNeutralBorderSubdued: '#E9E9E9FF',
    tagNeutralTextBold: '#FFFFFFFF',
    tagNeutralTextSubdued: '#1A1A1AFF',
    tagOneBackgroundBold: '#501CD2FF',
    tagOneBackgroundSubdued: '#EDEAF5FF',
    tagOneBorderBold: '#501CD2FF',
    tagOneBorderSubdued: '#EDEAF5FF',
    tagOneTextBold: '#FFFFFFFF',
    tagOneTextSubdued: '#1A1A1AFF',
    tagTwoBackgroundBold: '#135D03FF',
    tagTwoBackgroundSubdued: '#DEEADCFF',
    tagTwoBorderBold: '#135D03FF',
    tagTwoBorderSubdued: '#DEEADCFF',
    tagTwoTextBold: '#FFFFFFFF',
    tagTwoTextSubdued: '#1A1A1AFF',
    tagThreeBackgroundBold: '#994000FF',
    tagThreeBackgroundSubdued: '#F2EEE6FF',
    tagThreeBorderBold: '#994000FF',
    tagThreeBorderSubdued: '#F2EEE6FF',
    tagThreeTextBold: '#FFFFFFFF',
    tagThreeTextSubdued: '#1A1A1AFF',
    tagFourBackgroundBold: '#870644FF',
    tagFourBackgroundSubdued: '#F2E1F0FF',
    tagFourBorderBold: '#870644FF',
    tagFourBorderSubdued: '#F2E1F0FF',
    tagFourTextBold: '#FFFFFFFF',
    tagFourTextSubdued: '#1A1A1AFF',
    tagSuccessBackgroundBold: '#008A09FF',
    tagSuccessBackgroundSubdued: '#E3F7F0FF',
    tagSuccessBorderBold: '#008A09FF',
    tagSuccessBorderSubdued: '#E3F7F0FF',
    tagSuccessTextBold: '#FFFFFFFF',
    tagSuccessTextSubdued: '#02692BFF',
    tagWarningBackgroundBold: '#B85B0FFF',
    tagWarningBackgroundSubdued: '#FAE8D6FF',
    tagWarningBorderBold: '#B85B0FFF',
    tagWarningBorderSubdued: '#FAE8D6FF',
    tagWarningTextBold: '#FFFFFFFF',
    tagWarningTextSubdued: '#9F3703FF',
    tagCriticalBackgroundBold: '#DD0E0EFF',
    tagCriticalBackgroundSubdued: '#F9E1E2FF',
    tagCriticalBorderBold: '#DD0E0EFF',
    tagCriticalBorderSubdued: '#F9E1E2FF',
    tagCriticalTextBold: '#FFFFFFFF',
    tagCriticalTextSubdued: '#BB1111FF',
    tagInformationalBackgroundBold: '#2E5CDFFF',
    tagInformationalBackgroundSubdued: '#E8F8FFFF',
    tagInformationalBorderBold: '#2E5CDFFF',
    tagInformationalBorderSubdued: '#E8F8FFFF',
    tagInformationalTextBold: '#FFFFFFFF',
    tagInformationalTextSubdued: '#225ECEFF',
  },
  fonts: {
    headings:
      "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    headingOne: '$body',
    headingTwo: '$body',
    headingThree: '$body',
    headingFour: '$body',
    subtitleOne: '$body',
    subtitleTwo: '$body',
    bodyOne: '$body',
    bodyOneSecondary: '$body',
    bodyTwo: '$body',
    bodyTwoSecondary: '$body',
    buttonOne: '$body',
    buttonTwo: '$body',
    label: '$body',
    overline: '$body',
    caption: '$body',
    tab: '$body',
  },
  fontWeights: {
    headingOne: 600,
    headingTwo: 600,
    headingThree: 600,
    headingFour: 600,
    subtitleOne: 500,
    subtitleTwo: 500,
    bodyOne: 400,
    bodyOneSecondary: 400,
    bodyTwo: 400,
    bodyTwoSecondary: 400,
    buttonOne: 600,
    buttonTwo: 600,
    label: 500,
    overline: 700,
    caption: 400,
    tab: 500,
  },
  letterSpacings: {
    headingOne: '-1px',
    headingTwo: '-1px',
    headingThree: '-0.5px',
    headingFour: '-0.5px',
    subtitleOne: '-0.20000000298023224px',
    subtitleTwo: '-0.20000000298023224px',
    bodyOne: '-0.20000000298023224px',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: '-0.20000000298023224px',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: '-0.20000000298023224px',
    buttonTwo: '-0.20000000298023224px',
    label: '0',
    overline: '0',
    caption: '0',
    tab: '0',
  },
  textTransforms: {
    headingOne: 'none',
    headingTwo: 'none',
    headingThree: 'none',
    headingFour: 'none',
    subtitleOne: 'none',
    subtitleTwo: 'none',
    bodyOne: 'none',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: 'none',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: 'none',
    buttonTwo: 'none',
    label: 'none',
    overline: 'uppercase',
    caption: 'none',
    tab: 'none',
  },
  textDecorations: {
    headingOne: 'none',
    headingTwo: 'none',
    headingThree: 'none',
    headingFour: 'none',
    subtitleOne: 'none',
    subtitleTwo: 'none',
    bodyOne: 'none',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: 'none',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: 'none',
    buttonTwo: 'none',
    label: 'none',
    overline: 'none',
    caption: 'none',
    tab: 'none',
  },
  borderWidths: {
    thin: '1px',
    thick: '2px',
    outerFocus: '3px',
    innerFocus: '3px',
    card: '1px',
  },
  radii: {
    none: '0',
    thin: '1px',
    thick: '2px',
    small: '3px',
    medium: '6px',
    large: '9px',
    extraLarge: '16px',
    huge: '20px',
    circle: '99999px',
    pill: '99999px',
    button: '99999px',
    inputField: '8px',
    card: '12px',
    progressBar: '9999px',
    tags: '4px',
  },
  shadows: {
    card: '0px 0px 0px 0px #00000000',
    dropdown: '0px 4px 8px 0px #0000001A',
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  transitions: { defaultTime: '200ms' },
};
